import { render } from "./FallbackCard.vue?vue&type=template&id=4e239354"
import script from "./FallbackCard.vue?vue&type=script&lang=js"
export * from "./FallbackCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__